import * as Yup from 'yup'; 
import { personalIdParser } from '../../components/form/Helpers/Parsers'
import { FieldTypes, IFields } from '../../models/form/IFieldsDefinition'
import { isDateValid, isPersonalIdReleaseCorrect } from '../../components/form/Validations/DateValidation'
import { hasPersonalIdNumberCorrectFormat } from '../../components/form/Validations/PersonalIdNumberValidation'
import { FormValidationObject } from '../../models/form/IFormDefinition'

export enum ExtendedInfoFieldsNames {
   PersonalId = "PersonalId",
   PersonalIdRelease = "PersonalIdRelease",
   MaritalStatus = "MaritalStatus",
   Education = "Education",
}

const maritalStatusOptions = [
   { value: 'single',              label: 'Panna/Kawaler'},
   { value: 'married',             label: 'Związek małżeński'},
   { value: 'widowed',             label: 'Wdowa/wdowiec'},
   { value: 'divorced',            label: 'Rozwód'},
   { value: 'propertySeparation',  label: 'Rozdzielność majątkowa'},
   { value: 'separated',           label: 'Separacja'},
   { value: 'concubinage',         label: 'Związek nieformalny'},
]

const education = [
   { value: 'incompletePrimary', label: 'Podstawowe'},
   { value: 'postSecondary',     label: 'Średnie'},
   { value: 'basicVocational',   label: 'Zawodowe'},
   { value: 'bachelorEngineer',  label: 'Wyższe'},
]


export const extendedInfoFields: IFields = {
   [ExtendedInfoFieldsNames.PersonalId]: {
      order: 0,
      name: ExtendedInfoFieldsNames.PersonalId,
      type: FieldTypes.string,
      label: "Seria i numer dowodu",
      editable: true,
      mask: 'aaa999999',
      parser: personalIdParser,
   },
   [ExtendedInfoFieldsNames.PersonalIdRelease]: {
      order: 5,
      name: ExtendedInfoFieldsNames.PersonalIdRelease,
      type:  FieldTypes.date,
      label: "Data wydania dowodu",
      editable: true,
   },
   [ExtendedInfoFieldsNames.MaritalStatus]: {
      order: 15,
      name: ExtendedInfoFieldsNames.MaritalStatus,
      type:  FieldTypes.dropdown,
      options: maritalStatusOptions,
      label: "Stan cywilny",
      editable: true,
   },
   [ExtendedInfoFieldsNames.Education]: {
      order: 20,
      name: ExtendedInfoFieldsNames.Education,
      type:  FieldTypes.dropdown,
      options: education,
      label: "Wykształcenie",
      editable: true,
   },
}


export const extendedInfoFieldValidations: FormValidationObject<typeof ExtendedInfoFieldsNames> = {
   [ExtendedInfoFieldsNames.PersonalId]:  Yup.string().required("Niepoprawna wartość").test(hasPersonalIdNumberCorrectFormat) as Yup.StringSchema<string>,
   [ExtendedInfoFieldsNames.PersonalIdRelease]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isPersonalIdReleaseCorrect) as Yup.StringSchema<string>,
   [ExtendedInfoFieldsNames.MaritalStatus]: Yup.string().required("Wskaż swój stan cywliny") as Yup.StringSchema<string>,
   [ExtendedInfoFieldsNames.Education]: Yup.string().required("Wskaż swoje wykształcenie") as Yup.StringSchema<string>,
} 